export default __webpack_public_path__ + "static/media/kinder.56a1a632.png";